export default __webpack_public_path__ + "static/media/2P_GW214.a050e01d.png";